<template>
  <div
    class="container"
    :class="{ 'container--hidden': $store.getters.isPageLoaded }"
  >
    <div class="wrapper">
      <span class="span">
        {{ $store.state.loaderProgress }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    progress() {
      return this.$store.state.loaderProgress
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  @include fill-space;
  @include center-content;

  background: $background-color;
  color: $text-color;
  z-index: z(loader);
}

.span {
  font-size: 100px;
  font-family: $bold-font;
}

.container {
  @include fill-space;
  z-index: z(loader);
  opacity: 1;
  transition: opacity 0.4s ease-in-out 0.5s;

  &--hidden {
    opacity: 0;
    pointer-events: none;
  }
}
</style>
